export class ChapterWiseDataModel {
    id: number;
    chapter: number;
    noOfQns: number;
    subAbilityId: number;
    sectionWiseModel: number;
    constructor(chapter: number, noOfQns: number, sectionWiseModel: number, subAbilityId: number) {
        this.chapter = chapter;
        this.noOfQns = noOfQns;
        this.sectionWiseModel = sectionWiseModel;
        this.subAbilityId = subAbilityId;
    }
}
